module.exports = __webpack_public_path__ + "static/media/w_y_35.2be99321.png";